var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5.293.793 8l1 1h15.414V7H4.621l5.293-5.293L8.5.293ZM6.621 11H3.793L8.5 15.707l1.414-1.414L6.621 11Z",
    fill: "currentColor"
  })));
};

export { SvgArrowLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTggMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik04LjUwMDA4IDAuMjkyOTY5TDAuNzkyOTY5IDguMDAwMDhMMS43OTI1OSA5TDE3LjIwNyA5LjAwMDA4VjcuMDAwMDhINC42MjE0TDkuOTE0MjkgMS43MDcxOEw4LjUwMDA4IDAuMjkyOTY5WiIgZmlsbD0iY3VycmVudENvbG9yIi8+CjxwYXRoIGQ9Ik02LjYyMTAyIDExSDMuNzkyNTlMOC40OTk5MiAxNS43MDczTDkuOTE0MTQgMTQuMjkzMUw2LjYyMTAyIDExWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";